/* eslint-disable comma-dangle */

export default {
  address: [
    'coworking-name',
  ],
  'about-object': [
    'coworking-workplace-warning',
    'coworking-workplace-count',
    'coworking-floor',
    'coworking-access-type',
    'coworking-price',
    'coworking-min-lease-term',
  ],
};
